import { render } from "./FooterMenu.vue?vue&type=template&id=55ba360c&scoped=true&ts=true"
import script from "./FooterMenu.vue?vue&type=script&lang=ts"
export * from "./FooterMenu.vue?vue&type=script&lang=ts"

import "./FooterMenu.vue?vue&type=style&index=0&id=55ba360c&lang=stylus&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ba360c"]])

export default __exports__